const PATTERN = /^https?:\/\/./;

export default function isValidLink(url?: string | null): boolean {
  return url != null && PATTERN.test(url);
}
